module.exports = __webpack_public_path__ + "media/images/icon/ico_top_mv03-0f140cdee63b6733f159d7a467e7891f.svg";